<template>
<div class="TrainingField">
    <div class="TrainingField__thumbnail">
        <div class="TrainingField__thumbnail__wrap">
            <v-img width="100%" :aspect-ratio="16/9"
                   :src="trainingVideo.thumbnail.src"
                   class="TrainingField__thumbnail__image"
            ></v-img>
            <div v-if="!trainingDownload.url"
                 class="TrainingField__thumbnail__overlay"
                 @click="showVideo"
            >
            </div>
            <a v-else
               class="TrainingField__thumbnail__overlay"
               :href="storage + trainingDownload.url"
               target="_blank"
            >
            </a>
        </div>
    </div>
    <div class="TrainingField__lower">
        <h2 class="TrainingField__name">
            {{ name }}
        </h2>
        <p>
            {{ description }}
        </p>
    </div>

    <v-dialog v-model="videoDialog" max-width="1000px" :scrollable="false" style="overflow: hidden;">
        <v-card flat class="Video">
            <div class="Video__close">
                <v-btn color="primary" icon @click="videoDialog = false"><i class="fas fa-times-circle"></i></v-btn>
            </div>
            <div class="Video__overlay" :class="{jsPlayerReady:playerReady}">
                <v-container fluid fill-height>
                    <v-layout justify-center align-center>
                        <v-progress-circular indeterminate color="primary"> </v-progress-circular>
                    </v-layout>
                </v-container>
            </div>
            <div class="Video__container">
                <v-card-text class="ma-0 pa-0 Video__wrapper">
                    <youtube :video-id="trainingVideo.id" ref="youtube" :fit-parent="true" :resize="true" @ready="ready"></youtube>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import store from '@/store/store';

export default {
    props: {
        fieldId: {
            type: String,
            required: true
        },

        fieldNamespace: {
            type: String,
            required: true
        },

        cardNamespace: {
            type: String,
            required: true
        },
    },

    watch: {
        videoDialog: function() {
            this.player.stopVideo();
        }
    },

    computed: {
        name() {
            return store.state[this.fieldNamespace].name;
        },

        description() {
            return store.state[this.fieldNamespace].options.training.description;
        },

        trainingVideo() {
            return store.state[this.fieldNamespace].options.training.video;
        },

        trainingDownload() {
            return store.state[this.fieldNamespace].options.training.download;
        },

        player() {
            return this.$refs.youtube.player;
        }
    },

    data() {
        return {
            videoDialog: false,
            playerReady: false,
            storage: this.$storageURL,
        };
    },

    methods: {
        showVideo() {
            this.videoDialog = true;
        },

        ready() {
            setTimeout(() => {
                this.playerReady = true;
            }, 800);
        }
    }
};
</script>
<style lang="scss">
.TrainingField {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    padding: 0;

    @media (min-width: 600px) {
        padding: 0;
    }

    @media (min-width: 768px) {
        padding: 0;
    }
}

.TrainingField__lower {
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    padding: 18px;

    p:last-of-type {
        margin-bottom: 0 !important;
    }
}

.TrainingField__name {
    flex: 0 0 100%;
    width: 100%;
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1.2;
    margin-bottom: 12px !important;
}

.TrainingField__thumbnail {
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 100%;
    width: 100%;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.TrainingField__thumbnail__wrap {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.TrainingField__thumbnail__image {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
    z-index: 1;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;

    img {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }
}

.TrainingField__thumbnail__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    cursor: pointer;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;

    i {
        font-size: 3rem !important;
    }
}

.Video__container {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 56.25%;
    overflow: hidden;
}

.Video__wrapper {
    position: absolute;
    top: 0;
    z-index: 1;
    overflow: hidden;
}

.Video__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
    background-color: white;
    opacity: 1;
    transition: opacity 0.3s linear;

    &.jsPlayerReady {
        opacity: 0;
        transition: opacity 0.3s linear;
        pointer-events: none;
    }
}

.Video__close {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    flex: 0 0 100%;
    width: 100%;
    background-color: $neutral-900;
}

</style>
